import { useState } from 'react';
import Button from '../base/Button';
import { login, register } from '@/services/login';
import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { setUserInfo } from '@/store/userSlice';

interface AuthModalProps {
  mode: 'login' | 'register';
  onClose: () => void;
  onSwitchMode: (mode: 'login' | 'register') => void;
}


export default function AuthModal({ mode, onClose, onSwitchMode }: AuthModalProps) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    nickname: '',
    agreeTerms: false,
    rememberMe: false
  });

  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<{[key: string]: string}>({});
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // 清除对应字段的错误信息
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors: {[key: string]: string} = {};

    if (mode === 'register') {
      if (!formData.nickname.trim()) {
        newErrors.nickname = '请输入昵称';
      } else if (formData.nickname.length < 2) {
        newErrors.nickname = '昵称至少需要2个字符';
      }

      if (!formData.phone.trim()) {
        newErrors.phone = '请输入手机号';
      } else if (!/^1[3-9]\d{9}$/.test(formData.phone)) {
        newErrors.phone = '请输入正确的手机号';
      }


      // 邮箱非必填，若填写则校验格式
      if (formData.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = '请输入正确的邮箱格式';
      }

      if (!formData.password) {
        newErrors.password = '请输入密码';
      } else if (formData.password.length < 6) {
        newErrors.password = '密码至少需要6位';
      }

      if (!formData.confirmPassword) {
        newErrors.confirmPassword = '请确认密码';
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = '两次输入的密码不一致';
      }

      if (!formData.agreeTerms) {
        newErrors.agreeTerms = '请同意用户协议';
      }
    } else {
      // if (!formData.email.trim()) {
      //   newErrors.email = '请输入邮箱或手机号';
      // }
      if (!formData.nickname.trim()) {
        newErrors.nickname = '请输入昵称';
      } else if (formData.nickname.length < 2) {
        newErrors.nickname = '昵称至少需要2个字符';
      }
      if (!formData.password) {
        newErrors.password = '请输入密码';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setIsLoading(true);
    try {
      let res;
      console.log('注册结果:', 1);
      if (mode === 'login') {
        res = await login({ username: formData.nickname, password: formData.password });
      } else {
        res = await register({
          password: formData.password,
          password_confirm: formData.confirmPassword,
          mobile: formData.phone,
          username: formData.nickname,
        });

      }
      if (res && res.status === 1 && res.data?.token) {
        message.success(
          mode === 'login'
            ? `登录成功`
            : `注册成功，欢迎加入！`
        );
        dispatch(setUserInfo({
            token: res.data.token,
            id: res.data.id,
            username: res.data.username,
        }));
        localStorage.setItem('authToken', res.data.token);
        localStorage.setItem('userInfo',JSON.stringify(res.data));
      }
      console.log('注册结果:', res);
      if (!res || res.status !== 1) {
        message.error(res?.info || '请求失败，请重试');
        return;
      }
      // 成功后关闭弹窗
      onClose();
      resetForm();
    } catch (error) {
      setErrors(prev => ({ ...prev, submit: '请求失败，请重试' }));
       message.error(error?.info || '请求失败，请重试');
      console.error('提交失败:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      email: '',
      password: '',
      confirmPassword: '',
      phone: '',
      nickname: '',
      agreeTerms: false,
      rememberMe: false
    });
    setErrors({});
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  const handleSwitchMode = (newMode: 'login' | 'register') => {
    resetForm();
    onSwitchMode(newMode);
  };

  const handleThirdPartyLogin = (provider: string) => {
    console.log(`${provider} 登录`);
    // 这里处理第三方登录逻辑
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden animate-in slide-in-from-bottom-4 duration-300 flex flex-col">
        {/* 头部 */}
        <div className="relative bg-gradient-to-r from-green-500 to-emerald-600 text-white p-6 flex-shrink-0">
          <div className="absolute top-0 left-0 w-full h-full bg-[url('https://readdy.ai/api/search-image?query=modern%20sports%20stadium%20background%20with%20geometric%20patterns%2C%20professional%20clean%20design%20for%20login%20interface&width=400&height=200&seq=authbg123&orientation=landscape')] opacity-10 bg-cover bg-center"></div>
          <div className="relative">
            <button
              onClick={onClose}
              className="absolute top-0 right-0 w-8 h-8 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            <div className="pr-10">
              <h2 className="text-2xl font-bold mb-2">
                {mode === 'login' ? '欢迎回来' : '加入我们'}
              </h2>
              <p className="text-white/90 text-sm">
                {mode === 'login' 
                  ? '登录你的账号，继续体验精彩体育内容' 
                  : '创建账号，开启你的体育之旅'}
              </p>
            </div>
          </div>
        </div>

        {/* 表单内容 - 添加滚动容器 */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* 登录表单 */}
              {mode === 'login' && (
                <>
                  {/* 邮箱/手机号 */}
                  {/* <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      邮箱/手机号
                    </label>
                    <div className="relative">
                      <i className="ri-user-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="请输入邮箱或手机号"
                        className={`w-full pl-10 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.email ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                        required
                      />
                    </div>
                    {errors.email && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.email}
                      </p>
                    )}
                  </div> */}
                  {/* 昵称 */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      昵称
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <i className="ri-user-smile-line text-gray-400"></i>
                        <span className="ml-2 text-sm font-medium">BC</span>
                      </div>
                      <input
                        type="text"
                        name="nickname"
                        value={formData.nickname}
                        onChange={handleInputChange}
                        placeholder="请输入昵称"
                        className={`w-full pl-16 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.nickname ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                        required
                      />
                    </div>
                    {errors.nickname && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.nickname}
                      </p>
                    )}
                  </div>
                  {/* 密码 */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      密码
                    </label>
                    <div className="relative">
                      <i className="ri-lock-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="请输入密码"
                        className={`w-full pl-10 pr-12 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.password ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                      >
                        <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                      </button>
                    </div>
                    {errors.password && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.password}
                      </p>
                    )}
                  </div>

                  {/* 记住密码 & 忘记密码 */}
                  <div className="flex items-center justify-between">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        name="rememberMe"
                        checked={formData.rememberMe}
                        onChange={handleInputChange}
                        className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                      />
                      <span className="ml-2 text-sm text-gray-600">记住密码</span>
                    </label>
                    <button
                      type="button"
                      className="text-sm text-green-600 hover:text-green-700 cursor-pointer"
                    >
                      忘记密码？
                    </button>
                  </div>
                </>
              )}

              {/* 注册表单 */}
              {mode === 'register' && (
                <>
                  {/* 昵称 */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      昵称
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <i className="ri-user-smile-line text-gray-400"></i>
                        <span className="ml-2 text-sm font-medium">BC</span>
                      </div>
                      <input
                        type="text"
                        name="nickname"
                        value={formData.nickname}
                        onChange={handleInputChange}
                        placeholder="请输入昵称"
                        className={`w-full pl-16 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.nickname ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                        required
                      />
                    </div>
                    {errors.nickname && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.nickname}
                      </p>
                    )}
                  </div>

                  {/* 手机号 */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      手机号
                    </label>
                    <div className="relative">
                      <i className="ri-phone-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="请输入手机号"
                        className={`w-full pl-10 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.phone ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                        required
                      />
                    </div>
                    {errors.phone && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.phone}
                      </p>
                    )}
                  </div>

                  {/* 邮箱 */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      邮箱
                    </label>
                    <div className="relative">
                      <i className="ri-mail-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="请输入邮箱（选填）"
                        className={`w-full pl-10 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.email ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                      />
                    </div>
                    {errors.email && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.email}
                      </p>
                    )}
                  </div>

                  {/* 密码 */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      密码
                    </label>
                    <div className="relative">
                      <i className="ri-lock-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="请输入密码（6-20位）"
                        className={`w-full pl-10 pr-12 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.password ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                        required
                        minLength={6}
                        maxLength={20}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                      >
                        <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                      </button>
                    </div>
                    {errors.password && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.password}
                      </p>
                    )}
                  </div>

                  {/* 确认密码 */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      确认密码
                    </label>
                    <div className="relative">
                      <i className="ri-lock-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        placeholder="请再次输入密码"
                        className={`w-full pl-10 pr-12 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm transition-colors ${
                          errors.confirmPassword ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                        }`}
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                      >
                        <i className={showConfirmPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                      </button>
                    </div>
                    {errors.confirmPassword && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.confirmPassword}
                      </p>
                    )}
                  </div>

                  {/* 用户协议 */}
                  <div>
                    <div className="flex items-start space-x-3">
                      <input
                        type="checkbox"
                        name="agreeTerms"
                        checked={formData.agreeTerms}
                        onChange={handleInputChange}
                        className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500 mt-1 flex-shrink-0"
                        required
                      />
                      <label className="text-sm text-gray-600 leading-5">
                        我已阅读并同意
                        <button type="button" className="text-green-600 hover:text-green-700 cursor-pointer mx-1">
                          《用户协议》
                        </button>
                        和
                        <button type="button" className="text-green-600 hover:text-green-700 cursor-pointer ml-1">
                          《隐私政策》
                        </button>
                      </label>
                    </div>
                    {errors.agreeTerms && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {errors.agreeTerms}
                      </p>
                    )}
                  </div>
                </>
              )}

              {/* 提交按钮 */}
              <Button 
                type="submit"
                size="lg" 
                className="w-full mt-6 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-semibold py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 whitespace-nowrap"
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="flex items-center justify-center">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    {mode === 'login' ? '登录中...' : '注册中...'}
                  </div>
                ) : (
                  <>
                    <i className={`${mode === 'login' ? 'ri-login-box-line' : 'ri-user-add-line'} mr-2`}></i>
                    {mode === 'login' ? '立即登录' : '立即注册'}
                  </>
                )}
              </Button>
            </form>

            {/* 分割线 */}
            <div className="relative my-6">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-4 bg-white text-gray-500">或使用第三方登录</span>
              </div>
            </div>

            {/* 第三方登录 */}
            <div className="grid grid-cols-2 gap-3">
              <button 
                type="button"
                onClick={() => handleThirdPartyLogin('wechat')}
                className="flex items-center justify-center px-4 py-3 border border-gray-200 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-colors cursor-pointer group whitespace-nowrap"
              >
                <i className="ri-wechat-fill text-green-500 text-xl mr-2 group-hover:scale-110 transition-transform"></i>
                <span className="text-sm font-medium text-gray-700">微信</span>
              </button>
              
              <button 
                type="button"
                onClick={() => handleThirdPartyLogin('qq')}
                className="flex items-center justify-center px-4 py-3 border border-gray-200 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-colors cursor-pointer group whitespace-nowrap"
              >
                <i className="ri-qq-fill text-blue-500 text-xl mr-2 group-hover:scale-110 transition-transform"></i>
                <span className="text-sm font-medium text-gray-700">QQ</span>
              </button>
            </div>

            {/* 切换模式 */}
            <div className="text-center mt-6 p-4 bg-gray-50 rounded-xl">
              <span className="text-sm text-gray-600">
                {mode === 'login' ? '还没有账号？' : '已有账号？'}
              </span>
              <button
                type="button"
                onClick={() => handleSwitchMode(mode === 'login' ? 'register' : 'login')}
                className="ml-2 text-sm text-green-600 hover:text-green-700 font-semibold cursor-pointer hover:underline whitespace-nowrap"
              >
                {mode === 'login' ? '立即注册' : '立即登录'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
